export const SET_TOGGLE = 'SET_TOGGLE';
export const SET_THEME_TOGGLE = 'SET_THEME_TOGGLE';